export default {
  'InvoicesCard.invoice': { en: 'Invoice', fr: 'Facture' },
  'InvoicesCard.date': { en: 'Date', fr: 'Date' },
  'InvoicesCard.amount': { en: 'Amount', fr: 'Montant' },
};
